import type { FaireProductEntity } from "../../entity_types/product";

export const p_j52wa88bq2: FaireProductEntity = {
  token: "p_j52wa88bq2",
  type: "product",
  name: "Water Fountain - Happy Buddha <br>",
  brandToken: "b_brgwq19hx1",
  brandName: "Earths Elements Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/36677baa77ec2f75999e3e3c1a2a07dc6c36b3ac0fdd14bb4548d7380eb33264.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2129360b1483147aaf17d6483df0d786e973ca8ae3f3b7d8ea02ece38ef49127.jpeg",
  ],
  priceDollars: 27.71,
  description:
    'WF-HB\nHappy Buddha, 3 Tiered Fountain with crystal orb with lights and Happy Buddha Statue. Pump with USB Connector included.\n12"H x 8"W\nMin. 1\n\nBring serenity and joy to any space with our Water Fountain Happy Buddha. This charming fountain features a cheerful Buddha seated in bliss, with cascading water adding a soothing, tranquil ambiance. Perfect for home, office, or garden, this piece not only enhances your decor but also promotes a sense of peace and well-being.\n\nThe gentle sound of flowing water combined with the joyful presence of the Buddha brings positive energy and harmonious vibes to any area. Easy to set up and maintain, this exquisite fountain is not just a decorative piece, but a symbol of happiness and tranquility that transforms your surroundings into a haven of peace.\n\nElevate your metaphysical store\'s inventory with our premium products, now available at competitive wholesale rates.',
  tags: [],
  msrpDollars: 55.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:26.072Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
